import React from 'react'
import {
  Button, useDataProvider, useRecordContext, useRefresh, useResourceContext
} from 'react-admin';
import ImageEye from '@mui/icons-material/CheckBox';

const SupporTicketIsResolvedButton = (props) => {
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const record = useRecordContext();
  const resource = useResourceContext();
  if (!record || !resource) { return null; }

  return (
    <Button
      startIcon={props.enablesIcon ? <ImageEye /> : null}
      label={record.isResolved ? "Marcar como não resolvida" : "Marcar como resolvida"}
      variant={props.isOutlined ? "outlined" : undefined}
      onClick={() => {
        dataProvider.update(resource, { id: record.id, data: { isResolved: !record.isResolved }, previousData: { ...record } })
          .then(() => {
            refresh();
          })
          .catch(() => console.log("Erro na mensagem"));
      }}
    />
  );
};

export default SupporTicketIsResolvedButton;